<ng-container *ngIf="{
  searchOptions: searchOptions$ | async,
  pageRowsCount: pageRowsCount$ | async,
  totalRowsCount : totalRowsCount$ | async} as data">

  <!-- Summary + page size selector -->
  <div class="results-pane-title" *ngIf="data.totalRowsCount > 0">
    <div>Showing {{ data.pageRowsCount }} of {{ data.totalRowsCount }} recipients</div>
    <mat-form-field appearance="outline" class="remove-error-place">
      <mat-select [formControl]="perPageControl">
        <mat-option *ngFor="let amountPerPage of contactPerPageOptions" [value]="amountPerPage">{{ amountPerPage }} per
          page
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="hide-investor-name-message-sort" *ngIf="!(allowInvestorName$ | async) && data.totalRowsCount > 0">To find
    a specific contact by ID please use the Advanced Search field above
  </div>
  <!-- Data table -->
  <table mat-table [dataSource]="dataSource" [trackBy]="trackByFunction" class="gray-theme mat-elevation-z0" matSort
         matSortDisableClear (matSortChange)="sortData($event)" [matSortDirection]="(searchOptions$ | async).sortOrder"
         [matSortActive]="(searchOptions$ | async).orderBy" multiTemplateDataRows>
    <!-- Checkbox Column -->
    <ng-container *ngIf="selectMany" matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="gray-theme checkbox-col-header">
        <div class="flex flex-row align-items-center gap-1">
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [indeterminate]="selection.hasValue() && !(isAllSelected$ | async)"
                      [checked]="selection.hasValue() && (isAllSelected$ | async)" [disabled]="data.pageRowsCount === 0"
                      color="primary">
        </mat-checkbox>

        <button mat-icon-button class="header-delete-button" (click)="deleteMulitple()"
                *ngIf="deleteRow && deleteRow.observers.length > 0 && selection.selected.length > 0">
          <mat-icon class="notranslate">delete</mat-icon>
        </button>
      </div>
      </th>
      <td mat-cell class="gray-theme" *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? rowCheckToggle(row) : null"
                      [checked]="isRowChecked(row)" color="accent"></mat-checkbox>
      </td>
    </ng-container>

    <!-- Radio Button Column -->
    <ng-container *ngIf="!selectMany" matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="gray-theme radio-col-header"></th>
      <td mat-cell class="gray-theme recipient-radio-cell" *matCellDef="let row">
        <mat-radio-button (click)="$event.stopPropagation()" (change)="$event ? rowCheckToggle(row) : null"
                          [checked]="isRowChecked(row)">
        </mat-radio-button>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="FirstName" [disabled]="!(allowInvestorName$ | async)"
          class="name-col-header">Account holder
      </th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive name-cell">
        <ng-container *ngIf="allowInvestorName$ | async">
          <div class="full-name">
            {{ element.firstName | truncate: 30 }}
            {{ element.lastName | truncate: 30 }}
          </div>
          <div *ngIf="!(isAllContactsVisible$ | async)" class="nickname">Recipient {{ element.nickname | truncate: 10 }}
          </div>
        </ng-container>
        <ng-container *ngIf="!(allowInvestorName$ | async)">
          {{ element.nickname | truncate: 10 }}
        </ng-container>
      </td>
    </ng-container>

    <!-- Routing number Column -->
    <ng-container matColumnDef="routingNumber">
      <th mat-header-cell *matHeaderCellDef class="routing-number-col-header desktop">Routing No.</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive routing-number-cell desktop">
        {{ element.bankAccount.usAbaRoutingNumber }}
      </td>
    </ng-container>

    <!-- Account number Column -->
    <ng-container matColumnDef="accountNumber">
      <th mat-header-cell *matHeaderCellDef class="account-number-col-header desktop">Account No.</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive account-number-cell desktop">
        {{ element.bankAccount.accountNumber }}
      </td>
    </ng-container>

    <!-- Account type Column -->
    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef class="account-type-col-header desktop">Payment method</th>
      <td mat-cell *matCellDef="let element" class="lo_sensitive account-type-cell desktop">
        {{ element.bankAccount.paymentType | enumString: CrePaymentType }}
      </td>
    </ng-container>

    <!-- Tags Column -->
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef class="tags-col-header desktop">Tags</th>
      <td mat-cell *matCellDef="let element" class="tags-column-content desktop">
        <mat-chip-grid class="terra-chip">
          <mat-chip *ngFor="let c of element.contactTags" class="lo_sensitive">
            {{ c }}
          </mat-chip>
        </mat-chip-grid>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="actions-col-header"></th>
      <td mat-cell *matCellDef="let contact" class="actions" [class.hover]="showActions(contact)">
        <button *ngIf="viewTransactionHistory && viewTransactionHistory.observers.length > 0" mat-icon-button
                (click)="onViewTransactionHistory(contact); $event.stopPropagation(); (false)" disableRipple
                matTooltip="Transaction History" matTooltipClass="terra-tooltip-compact">
          <mat-icon class="notranslate">history</mat-icon>
        </button>
        <button *ngIf="editRow && editRow.observers.length > 0" mat-icon-button class="edit-button desktop"
                (click)="onEditRow(contact.id); $event.stopPropagation(); (false)" disableRipple matTooltip="Edit"
                matTooltipClass="terra-tooltip-compact">
          <mat-icon class="edit-icon notranslate">edit</mat-icon>
        </button>
        <button *ngIf="!contact.isAgentContact && deleteRow && deleteRow.observers.length > 0" mat-icon-button
                class="delete-button desktop" (click)="onDeleteRow(contact.id); $event.stopPropagation(); (false)" disableRipple
                matTooltip="Delete" matTooltipClass="terra-tooltip-compact">
          <mat-icon class="delete-icon notranslate">delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="mobile">&nbsp;</th>
      <td mat-cell *matCellDef="let element" class="mobile">
        <button mat-icon-button aria-label="expand row"
                (click)="(expandedElement = expandedElement === element.id ? null : element.id); $event.stopPropagation()">
          <mat-icon *ngIf="expandedElement !== element.id">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="expandedElement === element.id">keyboard_arrow_up</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="(displayedColumns$ | async).length" class="mobile">
        <div class="expanded-element-detail" [@detailExpand]="expandedElement === element.id? 'expanded' : 'collapsed'">
          <div class="expanded-element"><span class="expanded-element-header">Account Type:</span> {{
              element.bankAccount.paymentType | enumString: CrePaymentType
            }}
          </div>
          <div class="expanded-element"><span class="expanded-element-header">Account Nr:</span> {{
              element.bankAccount.accountNumber
            }}
          </div>
          <div class="expanded-element"><span class="expanded-element-header">Routing Nr:</span> {{
              element.bankAccount.usAbaRoutingNumber
            }}
          </div>
          <div class="expanded-element" *ngIf="isGp$ | async"><span class="expanded-element-header">Tags:</span>
            <mat-chip-grid class="terra-chip">
              <mat-chip *ngFor="let c of element.contactTags" class="lo_sensitive">
                {{ c }}
              </mat-chip>
            </mat-chip-grid>
          </div>
          <div class="expand-action">
            <button mat-icon-button class="edit-button" *ngIf="editRow && editRow.observers.length > 0"
                    (click)="onEditRow(element.id); $event.stopPropagation(); (false)" disableRipple matTooltip="Edit"
                    matTooltipClass="terra-tooltip-compact">
              <mat-icon class="edit-icon notranslate">edit</mat-icon>
            </button>
            <button mat-icon-button class="delete-button" *ngIf="!element.isAgentContact && deleteRow && deleteRow.observers.length > 0"
                    (click)="onDeleteRow(element.id); $event.stopPropagation(); (false)" disableRipple matTooltip="Delete"
                    matTooltipClass="terra-tooltip-compact">
              <mat-icon class="delete-icon notranslate">delete</mat-icon>
            </button>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns$ | async"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns$ | async" [class.selected-row]="isRowChecked(row)"
        [class.hide]="isLoading$ | async" (click)="rowCheckToggle(row)" (mouseover)="row.hover = true"
        (mouseout)="row.hover = false" class="value-row" [class.recipient-expanded-row]="expandedElement === row.id"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="recipient-detail-row mobile"></tr>
  </table>

  <!-- loader  -->
  <terra-loader *ngIf="isLoading$ | async"></terra-loader>

  <!-- Empty state -->
  <div class="empty-list-message"
       *ngIf="!(isLoading$ | async) && data.totalRowsCount == 0 && showMessageWhenListIsEmpty">
    <p>Add a new recipient</p>
  </div>

  <mat-paginator (page)="pageChange($event)" [length]="data.totalRowsCount" [hidePageSize]="true"
                 [pageSize]="data.searchOptions.pageSize" [pageIndex]="data.searchOptions.pageNumber"
                 *ngIf="data.totalRowsCount > 0"></mat-paginator>
</ng-container>
